import { createContext } from "react"
import { TipoDocument } from "./tipodocumentInterface"

interface PartnerContextProps {
    searchTerm: string,
    setSearchTerm: (value: string) => void,
    tipoDocumentData:TipoDocument,
    setTipoDocumentData: (value: TipoDocument) => void,
    edit: boolean,
    setEdit: (value: boolean) => void,
    reloadTable: boolean,
    setReloadTable: (value: boolean) => void
}

const PartnerContext = createContext<PartnerContextProps>({
    searchTerm: '',
    setSearchTerm: (value) => {},
    tipoDocumentData:{_id:'',nombre: '',descripcion: '',id_empresa: '',estado: true},
    setTipoDocumentData: (value) => {},
    edit: false,
    setEdit: (value) => {},
    reloadTable: false,
    setReloadTable: (value) => {},
})

export {PartnerContext}